import {
  Briefcase,
  FileBarChart,
  Handshake,
  LineChart,
  type LucideIcon,
  PiggyBank,
  Wrench,
  Zap,
} from "lucide-react";

/**
 * The single source of truth for "what module is this, visually" — icon +
 * label per module, shared between the launcher's tile grid
 * (`pages/launcher/LauncherPage.tsx`) and each module shell's sidebar header
 * (`Sidebar.tsx` for Sales, `GlobalSidebar.tsx` for the Global area), so an
 * module's identity (its icon, its name) reads identically everywhere the
 * user encounters it — the launcher tile you clicked is the same icon you
 * see pinned at the top of the sidebar once inside.
 */
export interface LauncherModule {
  key: string;
  label: string;
  description: string;
  icon: LucideIcon;
}

export const LAUNCHER_MODULES: LauncherModule[] = [
  {
    key: "budget-planning",
    label: "Budget Planning",
    description: "Forecast and plan customer energy budgets.",
    icon: PiggyBank,
  },
  {
    key: "deal-capture",
    label: "Deal Capture",
    description: "Supply deals, master contracts and legal entities.",
    icon: Handshake,
  },
  {
    key: "energy-advisor",
    label: "Energy Advisor",
    description: "RFQs, bid requests, and the advisor workspace.",
    icon: Briefcase,
  },
  {
    key: "energy-insights",
    label: "Energy Insights",
    description: "Usage trends and savings opportunities.",
    icon: Zap,
  },
  {
    key: "market-intelligence",
    label: "Market Intelligence",
    description: "Market pricing insight and benchmarking.",
    icon: LineChart,
  },
  {
    key: "operations",
    label: "Operations",
    description: "Matrix pricing, suppliers, payees, and tasks.",
    icon: Wrench,
  },
  {
    key: "reports",
    label: "Reports",
    description: "Cross-portfolio reporting and exports.",
    icon: FileBarChart,
  },
];

// `GLOBAL_APP` used to live here — a keyless `as const` outside the array,
// because "Global" wasn't really a module: it was a separate destination
// holding both shared records and config. It's gone. Records became shared
// nav modules surfaced inside every module (`lib/nav-records.tsx`) and config
// became the Admin module (`lib/modules/admin-module.tsx`), which is a normal
// registry entry with a key like any other.
